import { isEmpty } from 'lodash';

export const isLuggageEnabled = (state) =>
  !isEmpty(state.sealink?.luggage?.luggageCategories);
